import { apiSlice } from '../api/apiSlice';
import { CheckoutParams, CheckoutResponse } from './checkoutApiSliceTypes';

const checkoutApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    checkout: builder.mutation<CheckoutResponse, CheckoutParams>({
      query: (params) => ({
        url: '/orders/checkout',
        method: 'Post',
        headers: {
          'Accept-Language': params.language || 'en',
        },
        body: {
          packageId: params.packageId,
          promoCode: params.promoCode,
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const { useCheckoutMutation } = checkoutApiSlice;
